<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button  
        *ngIf="isModal"
        icon-only 
        (click)="onDismiss()" 
        class='sm-clickable'>
        <ion-icon name="close"></ion-icon>
      </ion-button>

      <ion-button 
        *ngIf="!isModal" 
        icon-only 
        menuToggle 
        class='sm-clickable'>
        <ion-icon name="menu"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      Activity
    </ion-title>

    <ion-buttons slot="end">
      <ion-button 
        icon-only
        (click)="onNotificationSettingsTap()"
        class='sm-clickable'>
        <ion-icon name="cog"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <smr-stylist-picker
    [stylistID]="stylistID" 
    [readOnly]="readOnlyStylistPicker"
    (onInit)="onStylistPickerInit($event)"
    (stylistSelect)="onStylistSelect($event)"
    >  
  </smr-stylist-picker>
  
  <div class='sm-activity-list'>
    
    <ion-item *ngIf="activities.count() == 0">
      <ion-note>No new activity to show</ion-note>
    </ion-item>

    <ion-card *ngFor="let activity of activities" >
      <ion-card-header>
        {{ activity.getActionName() }}&nbsp; <ion-icon class="sm-clickable" item-right name='arrow-forward'></ion-icon>

        <ion-note item-right class='sm-activity-list-timestamp'>
        {{ timeElapsed(activity) }}
        </ion-note>
      </ion-card-header>

      <ion-list>
        <ion-button ion-item *ngIf="activity.getBooking()">
          <circle-text-avatar
              item-left 
              [firstName]="activity.getBooking().getClient().getFirstName()"
              [lastName]="activity.getBooking().getClient().getLastName()"
            >
          </circle-text-avatar>

          <div>

            <span class='sm-activity-list-client-name'>
            {{ activity.getBooking().getClient().getFirstName() }} {{ activity.getBooking().getClient().getLastName() }}</span> 
            <br />
            {{ activity.getBooking().getStartDateTime() | salonMonsterDate: 'dddd, MMMM D, Y' }}
            <br/>

            <span *ngFor="let service of activity.getBooking().getServices(); let currentIndex = index;">
              {{ service.getServiceDefinition().getServiceName() }}{{ (currentIndex != activity.getBooking().getServices().size - 1) ?  ',' : '' }}
            </span>
          </div>
        
        </ion-button>
      </ion-list>      
    </ion-card>

    <salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>
  </div>
</ion-content>
